import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

// https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=41444838
const initialState: {
  order_id?: string
  client_secret?: string
  api_key?: string
  err_msg?: string
  token_invalid?: boolean
} = {}
export const new_stripe_get_ext_info = createAsyncThunk(
  'Wallet2StripeNew/new_stripe_get_ext_info',
  async (params: any, store) => {
    const resp = await http.post<HiyaRes<typeof initialState>>(
      '/live/pay/new_stripe_get_ext_info',
      {
        ...params,
        from: 'external_recharge',
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export const new_stripe_update_payment_intent = createAsyncThunk(
  'Wallet2StripeNew/new_stripe_update_payment_intent',
  async (params: any, store) => {
    const resp = await http.post<HiyaRes<typeof initialState>>(
      '/live/pay/new_stripe_update_payment_intent',
      {
        ...params,
        from: 'external_recharge',
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)
export const Wallet2StripeNewSlice = createSlice({
  name: 'Wallet2StripeNew',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(new_stripe_get_ext_info.fulfilled, (state, action) => {
      Object.assign(state, {
        ...action.payload,
        order_id: action.meta.arg?.order_id,
      })
    })
  },
})
export const Wallet2StripeNewSliceActions = Wallet2StripeNewSlice.actions
export default Wallet2StripeNewSlice.reducer
export const useWallet2StripeNewState = () => {
  const data = useSelector((state) => state.Animal_Zebra_new)
  return data
}
